export const AboutCompany = () => {
    return (
        <section>
        <h1>About Company</h1>
        <p>
            
        </p>
        </section>
    )
}